import { ref, computed } from "vue";

/**
 * @NOTE: This doesn't exist in API form. It's set based on the data of the user state
 * 
 * @returns {Object<details: Ref<Object>>}
 */
export default function createMemberData(){

    const details = ref({})

    const has_individual_memberships = computed(
        () => details.value?.individual_member?.membership_count > 0
    )

    const has_organisation_memberships = computed(
        () => details.value?.organisation_member?.membership_count > 0
    )

    return {
        details: details,

        /**
         * If the current member has a contact for their individual member
         */
        has_individual_contact: computed(
            () => details.value?.individual_member?.contact !== undefined
        ),

        /**
         * If the current member has a contact for their organisation member
         */
        has_organisation_contact: computed(
            () => details.value?.organisation_member?.contact !== undefined
        ),

        /**
         * If we have memberships of the individual type
         */
        has_individual_memberships: has_individual_memberships,

        /**
         * If we have memberships for our organisation
         */
        has_organisation_memberships: has_organisation_memberships,

        /**
         * If we have any form of memberships
         */
        has_memberships: computed(
            () => has_individual_memberships.value || has_organisation_memberships.value
        ),
    }
}